//ElevationProfile.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as MainMap from "../MainMap";
import * as PrevTool from "../Menus/PrevTool";
import * as Util from "../Util/Util";
import * as WidgetHeading from "./WidgetHeading";

import { Container, CssBaseline, Zoom } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

const toolName = "Elevation Profile";
let toolDiv: string;

export let elevationProfileWidget: __esri.ElevationProfile = null;
let elevationProfileRoot: ReactDOM.Root = null;
let elevationProfile_div: HTMLDivElement;
let fadeIn: boolean;

//Show the widget.
export function show() {
   Util.logMsg("Showing elevation profile");

   if (!elevationProfileWidget) {
      elevationProfile_div = document.getElementById("elevationProfileDiv") as HTMLDivElement;
      elevationProfileRoot = ReactDOM.createRoot(elevationProfile_div);
   }

   fadeIn = true;
   elevationProfile_div.hidden = false;
   elevationProfileRoot.render(<Render />);
}

//Destroy the widget.
export function destroy() {
   if (elevationProfileWidget) {
      Util.logMsg("Destroying elevation profile");

      elevationProfileWidget = null;
      elevationProfile_div.hidden = true;
      elevationProfileRoot.unmount();
      elevationProfileRoot = null;
   }
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of elevation profile Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      import("@arcgis/core/widgets/ElevationProfile").then(({ default: ElevationProfile }) => {

         if (!elevationProfileWidget) {

            elevationProfileWidget = new ElevationProfile({
               container: toolDiv,
               view: MainMap.activeView,
               unit: "imperial",
               profiles: [{ type: "ground" }],
               visibleElements: {
                  legend: false,
                  sketchButton: true,
                  selectButton: false,
               },
            });

         }
      }).catch((error: Error) => {
         Util.errMsg('An error occurred while loading the Elevation Profile Widget module:', error);
      });
   }, []);

   function hide() {
      PrevTool.classRef.refresh(toolName);
      localStorage.SetItem("prevToolText", toolName);

      fadeIn = false;
      refresh();
   }

   //Animation is complete.
   function fadeInCompleted() {
      elevationProfileWidget.visible = true;
   }
   function fadeOutCompleted() {
      if (elevationProfileWidget) {
         elevationProfileWidget.visible = false;
         elevationProfile_div.hidden = true;
      }
   }

   toolDiv = "elevation-profile-id-" + MainMap.view2D.toString();

   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />

         <Zoom in={fadeIn} timeout={500} onEntered={() => fadeInCompleted()} onExited={() => fadeOutCompleted()}>
            <Container maxWidth="xl" style={{ minHeight: 300 }}>
               <WidgetHeading.Render title={toolName} onClose={hide} />
               <div id={toolDiv} key={toolDiv} ></div>
            </Container>
         </Zoom>

      </ThemeProvider>
   ); //end return.

} //end function.
